module.exports = __webpack_public_path__ + "assets/onetrust.c052f84b.svg";